export default "__VITE_ASSET__WIe5cZSe__"